module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/step03-ee99990d05a0f4dd376e155ef82c44e5.png";